// extracted by mini-css-extract-plugin
module.exports = {"footer":"TdSaveButton_footer__1I6Wx","button":"TdSaveButton_button__1n5In"};